module.exports = __webpack_public_path__ + "static/favicon-00590e9600eb7a5a5a610bedb8776416.ico";